import { Button } from "@material-ui/core";
import { Autocomplete, TextField } from "@mui/material/";
import React, { useContext, useState } from "react";
import "../App.css";
import BuildMetricTable from "./BuildMetricTable";
import { SystemContext } from "../context";
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CustomSnackbar from '../CustomSnackbar';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';

const BuildMLModel = ({ fetchAPI }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState('');
  const [enableDownload, setEnableDownload] = useState(false);
  const { fileName, taskToDoValue, targetVariableValue, cleanFlag, numberOfModelsToTrain, setNumberOfModelsToTrain, keyMetricValue, setKeyMetricValue, actualFileName, images, setImages, table1Data, setTable1Data, table2Data, setTable2Data, table3Data, setTable3Data, modelName, setModelName } =
    useContext(SystemContext);
  // const [numberOfModelsToTrain, setNumberOfModelsToTrain] = useState([]);
  const [modelError, setModelError] = useState(false);
  const [keyMetricError, setKeyMetricError] = useState(false);
  const [processpickleDownload, setProcessPickleDownload] = useState("")
  const [modelpickleDownload, setModelPickleDownload] = useState("")

  // const [table1Data, setTable1Data] = useState([]);
  // const [table2Data, setTable2Data] = useState([]);
  // const [table3Data, setTable3Data] = useState([]);
  // const [modelName, setModelName] = useState("");
  const [buildStatusMsg, setBuildStatusMsg] = useState('');


  const [modelsToTrainOptions, setModelsToTrainOptions] = useState({
    Classification: [
      "Logistic Regression",
      "K Neighbors Classifier",
      "Naive Bayes",
      "Decision Tree Classifier",
      "SVM - Linear Kernel",
      "SVM - Radial Kernel",
      // "Gaussian Process Classifier",
      "MLP Classifier",
      // "Ridge Classifier",
      "Random Forest Classifier",
      "Quadratic Discriminant Analysis",
      "Ada Boost Classifier",
      "Gradient Boosting Classifier",
      "Linear Discriminant Analysis",
      "Extra Trees Classifier",
      // "Extreme Gradient Boosting", Removed from info by Akshita kola
      // "Light Gradient Boosting Machine",
      "Dummy Classifier",
    ],
    Regression: [
      "Linear Regression",
      "Lasso Regression",
      "Ridge Regression",
      "Elastic Net",
      "Least Angle Regression",
      "Lasso Least Angle Regression",
      "Orthogonal Matching Pursuit",
      "Bayesian Ridge",
      "Automatic Relevance Determination",
      "Passive Aggressive Regressor",
      "Random Sample Consensus",
      "TheilSen Regressor",
      "Huber Regressor",
      // "Kernel Ridge",  Removed from info by Akshita kola
      // "Support Vector Regression",
      "K Neighbors Regressor",
      "Decision Tree Regressor",
      "Random Forest Regressor",
      "Extra Trees Regressor",
      "AdaBoost Regressor",
      "Gradient Boosting Regressor",
      "MLP Regressor",
      // "Extreme Gradient Boosting", 
      "Light Gradient Boosting Machine",
      "Dummy Regressor",
    ],
    Clustering: [
      "K-Means Clustering",
      "Affinity Propagation",
      "Mean Shift Clustering",
      "Spectral Clustering",
      "Density-Based Spatial Clustering of Applications with Noise",
      "Optics Clustering",
      "BIRCH (Balanced Iterative Reducing and Clustering using Hierarchies)",
    ],
  });

  const [keyMetricOptions, setKeyMetricOptions] = useState({
    Classification: ["Recall", "AUC", "Accuracy", "F1", "Kappa", "MCC"],
    Regression: ["MAE", "MSE", "RMSE", "R2", "RMSLE", "MAPE"],
    Clustering: ["Silhouette", "Calinski-Harabasz", "Davies-Bouldin"],
  });

  // const [keyMetricValue, setKeyMetricValue] = useState("");
  const [loading, setLoading] = useState(false);

  // const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  const handleModelsToTrain = (evt, value) => {
    setModelError(false);
    setNumberOfModelsToTrain(value);
  };
  const handleKeyMetric = (evt, value) => {
    setKeyMetricError(false);
    setKeyMetricValue(value);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleTrainModelSubmit = async (event) => {
    let flag = false;

    // Validate input fields
    if (numberOfModelsToTrain && numberOfModelsToTrain.length === 0) {
      setModelError(true);
      flag = true;
    }
    if (!keyMetricValue) {
      setKeyMetricError(true);
      flag = true;
    }

    if (flag) {
      return;
    }

    setLoading(true);
    setProcessPickleDownload("");
    setModelPickleDownload("");
    const data_sys = {
      filename: actualFileName,
      Task: taskToDoValue,
      target: targetVariableValue,
      choices: {
        models: numberOfModelsToTrain,
        key_metric: keyMetricValue,
      },
    };

    try {
      const trainResponse = await fetchAPI.post("/train_models", data_sys, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        },
      });

      if (trainResponse.status === 202) {
        const checkTrainStatus = async () => {
          try {
            const statsResponse = await fetchAPI.post("/training_stats", { filename: actualFileName }, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
              },
            });

            if (statsResponse.status === 200) {
              const responseData = statsResponse.data.json_data;
              console.log(statsResponse.data.process_pickle)
              console.log(responseData.data.model_pickle)
              setTable1Data(responseData.data.train_metrics);
              setTable2Data(responseData.data.test_metrics);
              setModelName(responseData.data.model_name);
              // setPickleDownload(responseData.process_pickle)
              setProcessPickleDownload(statsResponse.data.process_pickle)
              setModelPickleDownload(responseData.data.model_pickle)

              setImages(responseData.images);

              setBuildStatusMsg("Model training successfull!");
              setSnackbarOpen(true);
              setSnackbarType("success");
              setEnableDownload(true);
              setLoading(false);
            } else {
              setTimeout(checkTrainStatus, 2000);
            }
          } catch (error) {
            console.error("Error fetching training status:", error);
            setBuildStatusMsg(error.response?.data?.message || "An error occurred while fetching training status.");
            setSnackbarType("error");
            setSnackbarOpen(true);
          }
        };

        checkTrainStatus();
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setBuildStatusMsg(error.response?.data?.message || "An error occurred while uploading the file.");
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };


  const boxStyle = {
    borderRadius: "15px",
    border: "2px solid #ccc",
    padding: "20px",
    margin: "20px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f9f9f9",
    width: "auto",
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
  };

  const handleGetGraphs = async () => {
    const data_sys = {
      filename: fileName,
    };
    try {
      const response = await fetchAPI.post("/model_images", data_sys, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        },
      });
      setImages(response.data);
      setError("");
    } catch (error) {
      console.error("Error fetching images:", error);
      setImages([]);
      setError(
        "Failed to fetch images. Please make sure the filename is correct."
      );
    }
  };

  const handleDownload = async () => {
    // API URLs to fetch S3 download links
    const apiUrls = [
      `/download?key=${modelpickleDownload}`,
      `/download?key=${processpickleDownload}`
    ];

    // Example file names
    const fileNames = ["model_pickle.pkl", "process_pickle.pkl"];

   
    try {
      const responses = await Promise.all(apiUrls.map(url => fetchAPI.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        }
      })));


      console.log(responses)
      // const downloadUrls = await Promise.all(
      //   responses.map(response => {
      //     console.log(response.data.url)
      //     window.open(response.data.url, "_blank");
      //     return response.data.url; // Assuming API returns a plain S3 URL
      //   })
      // );

      responses.forEach((response, index) => {
        const downloadUrl = response.data.url;
        const fileName = fileNames[index];
        
        fetch(downloadUrl)
          .then(res => res.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          });
      });

      
    } catch (error) {
      console.error("Error fetching S3 download links:", error);
    }
  };

  // const handleDownload = () => {
  //   // Example pickleDownloads (replace with your actual data)
  //   const pickleDownloads = [
  //     modelpickleDownload, // Replace with actual Base64 strings
  //     processpickleDownload,
  //   ];

  //   // Example file names
  //   const fileNames = ["model_pickle.pkl", "process_pickle.pkl"];

  //   downloadPickleFiles(pickleDownloads, fileNames);
  // };

  const downloadPickleFiles = (pickleDownloads, fileNames) => {
    if (!Array.isArray(pickleDownloads) || pickleDownloads.length === 0) {
      console.error("No pickle data found!");
      return;
    }

    try {
      pickleDownloads.forEach((pickleDownload, index) => {
        if (!pickleDownload) {
          console.error(`Pickle data at index ${index} is empty!`);
          return;
        }

        // Decode the base64 string to binary
        const binaryData = atob(pickleDownload);

        // Convert binary data to a Uint8Array
        const byteArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
        }

        // Create a Blob from the binary data
        const blob = new Blob([byteArray], { type: "application/octet-stream" });

        // Create a URL for the Blob and trigger the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Use the provided file name or fallback to a default name
        const fileName = fileNames?.[index] || `downloaded_data_${index + 1}.pkl`;
        link.download = fileName; // Set the download file name
        link.click();

        // Cleanup
        URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.error("Error decoding and downloading pickle files:", error);
    }
  };

  // const downloadPickleFile = () => {
  //   if (!pickleDownload) {
  //     console.error("No pickle data found!");
  //     return;
  //   }

  //   try {
  //     // Decode the base64 string to binary
  //     const binaryData = atob(pickleDownload);

  //     // Convert binary data to a Uint8Array
  //     const byteArray = new Uint8Array(binaryData.length);
  //     for (let i = 0; i < binaryData.length; i++) {
  //       byteArray[i] = binaryData.charCodeAt(i);
  //     }

  //     // Create a Blob from the binary data
  //     const blob = new Blob([byteArray], { type: "application/octet-stream" });

  //     // Create a URL for the Blob and trigger the download
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = "downloaded_data.pkl"; // Set the download file name
  //     link.click();

  //     // Cleanup
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Error decoding and downloading pickle file:", error);
  //   }
  // };

  return (
    <>
      <div style={boxStyle}>
        <h2
          style={{ display: "flex", justifyContent: "start", color: "#152C73", maxWidth: '100vh' }}
        >
          <b>Build ML model</b>
        </h2>

        <ul>
          <Autocomplete
            id="combo-box-demo"
            multiple
            options={
              taskToDoValue.length > 0
                ? modelsToTrainOptions[taskToDoValue]
                : [""]
            }
            value={numberOfModelsToTrain}
            fullWidth
            style={{ display: "flex", marginBottom: "10px", width: "50%" }}
            autoHighlight={true}
            onChange={handleModelsToTrain}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Model to train"
                placeholder="Choose the models to train and evaluate"
                error={modelError}
                helperText={modelError ? 'Model is mandatory' : ''}
              />
            )}
          />
          <Autocomplete
            id="combo-box-demo"
            options={
              taskToDoValue.length > 0 ? keyMetricOptions[taskToDoValue] : [""]
            }
            value={keyMetricValue}
            fullWidth
            style={{ display: "flex", marginBottom: "10px", width: "50%" }}
            autoHighlight={true}
            onChange={handleKeyMetric}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Choose the key metric"
                placeholder="Choose the key metric"
                error={keyMetricError}
                helperText={keyMetricError ? 'Key metric is mandatory' : ''}
              />
            )}
          />
        </ul>
        <div
          style={{
            display: "flex",
            marginTop: "1rem",
            justifyContent: "center",
          }}
        >
          <div >
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={handleTrainModelSubmit}
              style={{  marginLeft: '1rem' ,borderRadius:'16px'}}
            // sx={{ fontSize: "1.5rem", padding: "0.8rem 2rem" }}
            >
              Train Model
            </Button>
            <Button
              type="button"
              variant="contained"
              onClick={handleDownload}
              color="primary"
              disabled={!enableDownload}
              style={{marginLeft:"0.5rem", width: "210px",borderRadius:'16px'}}
              
            >
              Download Pickles <DownloadIcon sx={{ fontSize: 25 }} />
            </Button>

            {/*<IconButton
              color="primary"
              onClick={handleDownload}
              disabled={!enableDownload} // Disable based on state
              aria-label="download"
              
            >
              <DownloadIcon sx={{fontSize: 35}} />
            </IconButton>*/}


          </div>

          {/* {enableDownload && } */}

          {loading && (
            <div style={overlayStyle}>
              <div className="loader"></div>
            </div>
          )}
        </div>
        <CustomSnackbar open={snackbarOpen} onClose={handleSnackbarClose} snackbarType={snackbarType}
          message={
            snackbarType === 'success' ? buildStatusMsg :
              snackbarType === 'warning' ? "Upload warning" :
                snackbarType === 'error' ? buildStatusMsg :
                  ""
          }
        />

        {
          !cleanFlag && <Alert severity="warning" style={{ width: "39%", marginTop: "2%", marginLeft: "33%", backgroundColor: "lightyellow" }}>Please perform Data cleaning and Feature Processing, as it is mandatory to Build your model !!!</Alert>
        }
        {table1Data && table1Data.length > 0 ? (
          <div style={{
            display: "flex",
            flexDirection: 'column',
            marginTop: "2rem",
            justifyContent: "start",
            width: "150vh",
            // height: "50vh",
          }}>
            <h3 style={{ color: '#152C73' }}>Model Selection</h3>
            <BuildMetricTable data={table1Data} />
            <p>Selected models(Validation data): {numberOfModelsToTrain.join(', ')}</p>
          </div>
        ) : (
          ""
        )}

        {table2Data && table2Data.length > 0 ? (
          <div style={{
            display: "flex",
            flexDirection: 'column',
            marginTop: "2rem",
            justifyContent: "start",
            width: "150vh",
            // height: "50vh",
          }}>
            <h3 style={{ color: '#152C73' }}>{modelName} metrics(Test data)</h3>
            <BuildMetricTable data={table2Data} />
          </div>
        ) : (
          ""
        )}

        {table3Data && table3Data.length > 0 ? (
          <div style={{
            display: "flex",
            flexDirection: 'column',
            marginTop: "2rem",
            justifyContent: "start",
            width: "100vh",
            // height: "50vh",
          }}>
            <h3 style={{ color: '#152C73' }}>Tuning metrics</h3>
            <BuildMetricTable data={table3Data} />
          </div>
        ) : (
          ""
        )}

        <div>
          {error && <p>{error}</p>}
          {/* <div>
            {images.map((image, index) => (
              <div key={index}>
                <h3>{image.name}</h3>
                <img
                  src={`data:image/png;base64,${image.data}`}
                  alt={image.name}
                />
              </div>
            ))}
          </div> */}
          <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
              {images.map((image, index) => (
                <div key={index} style={{ flex: '1 1 calc(50% - 20px)', boxSizing: 'border-box' }}>
                  <h3>{image.name.replace(".png", "")}</h3>
                  <img
                    src={`data:image/png;base64,${image.data}`}
                    alt={image.name}
                    style={{ width: '100%', height: 'auto' }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BuildMLModel;
